module.exports = __webpack_public_path__ + "img/about_us_3.27a83b3c.png";